/**
 * @description 企业权限相关接口
 */
import { baseUrl } from "@/requestConfig/baseUrl";
import axios from "@/requestConfig/intercept";
const cs = baseUrl.cs;

class enterprisePowerApi {
  // 财务大管家部门树
  GetAgentDepartTreeViews(params: { IsLookUser: boolean; UserId?: string }) {
    return axios.get(`${cs}/AgentDepartAuthor/GetAgentDepartTreeViews`, { params });
  }
  // 添加部门
  AddagentDepart(params: { id: number; agentdepartname: string | null }) {
    return axios.post(`${cs}/AgentDepartAuthor/AddagentDepart`, params);
  }
  // 修改部门
  EditagentDepart(params: { agentdepartId: string | null; agentdepartname: string | null }) {
    return axios.put(`${cs}/AgentDepartAuthor/EditagentDepart`, params);
  }
  // 删除部门
  DeleteagentDepart(params: { AgentDepartIds: string }) {
    return axios.delete(`${cs}/AgentDepartAuthor/DeleteagentDepart`, { params });
  }
  // 管理台-列表
  GetUserFinancial(params: { AgentDepartIds: string }) {
    return axios.get(`${cs}/UserFinancialManage/GetUserFinancial`, { params });
  }
  // 获取客户管理权限树
  GetUserPermissionCheckedTreeSimple(agentUserId: string) {
    return axios.get(`${cs}/AgentPermission/GetUserPermissionCheckedTreeSimple/${agentUserId}`);
  }
  // 获取客户管理权限列表
  GetUserPermission(agentUserId: string) {
    return axios.get(`${cs}/AgentPermission/GetUserPermission/${agentUserId}`);
  }
}

// 单列模式返回对象
let instance;
export default (() => {
  if (instance) return instance;
  instance = new enterprisePowerApi();
  return instance;
})();
